<div class="toolbar">
  <span>
    <button matButton="text" (click)="backToPersonDetail()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <label>Back To Person</label>
      </span>
    </button>
  </span>
</div>
<div class="rolesLayout">
  <table>
    <tbody>
      <tr>
        <td class="leftColumn">
          <table class="rolesTable">
            <thead>
              <tr>
                <td class="rolesTableCell centeredCell rolesTableHeaderCell">Available Roles</td>
              </tr>
            </thead>
            @for (availableRole of availableRoles(); track availableRole) {
              <tr
                [style.background-color]="availableRole.id === selectedRole().id ? '#D3D3D3' : '#FFFFFF'"
                (click)="selectAvailableRole(availableRole)">
                <td class="rolesTableCell">{{ availableRole.name }}</td>
              </tr>
            }
          </table>
        </td>
        <td class="buttonColumn">
          <div>
            <span>
              <button class="arrowButton" matButton="text" [disabled]="!clickedAvailableRole()" (click)="addUserRole()">
                <span>
                  <mat-icon class="size-16">keyboard_arrow_right</mat-icon>
                </span>
              </button>
              <button class="arrowButton" matButton="text" [disabled]="!clickedAssignedRole()" (click)="removeUserRole()">
                <span>
                  <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
                </span>
              </button>
            </span>
          </div>
        </td>
        <td class="rightColumn">
          <table class="rolesTable">
            <thead>
              <tr>
                <td class="rolesTableCell centeredCell rolesTableHeaderCell">Assigned Roles</td>
              </tr>
            </thead>
            @for (assignedRole of assignedRoles(); track assignedRole) {
              <tr
                [style.background-color]="assignedRole.id === selectedRole().id ? '#D3D3D3' : '#FFFFFF'"
                (click)="selectAssignedRole(assignedRole)">
                <td class="rolesTableCell">{{ assignedRole.name }}</td>
              </tr>
            }
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>

